export const MIXPANEL_ACTION_TYPES = {
  REDIRECT: {
    ASSET_DASHBOARD: 'Redirect - Asset Dashboard',
  },
};
